import { render, staticRenderFns } from "./ErrorInactive.vue?vue&type=template&id=068f6af8&"
import script from "./ErrorInactive.vue?vue&type=script&lang=js&"
export * from "./ErrorInactive.vue?vue&type=script&lang=js&"
import style0 from "./ErrorInactive.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VImg } from 'vuetify/lib/components/VImg';
installComponents(component, {VBtn,VContainer,VImg})
